// ZEN-770 round 4 (owner, 16 Oct 2026): an overpaid advance says so, in its own currency.
import { money } from "@/lib/format";

export const isOverpaid = (remaining) => Number(remaining) < -0.005;
export const overpaidBy = (remaining, cur) => `Overpaid by ${money(-remaining, cur)}`;
const est = (a) => (a.remaining_is_estimate ? " (estimate)" : "");

// The per-advance figure: "CAD 360.00", or "Overpaid by CAD 50.00", with "(estimate)" when it is one.
export const owedFigure = (a) =>
  (isOverpaid(a.remaining) ? overpaidBy(a.remaining, a.currency) : money(a.remaining, a.currency)) + est(a);
